import React from "react"

const ScrollAnimation = ({ width='72', height='72', viewBox='0 0 72 72', className='scroll-animation' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="mouse">
      <path
        d="M36.933 15h-1.866C30.63 15 27 18.515 27 22.81v12.38c0 4.295 3.63 7.81 8.067 7.81h1.866C41.37 43 45 39.485 45 35.19V22.81c0-4.295-3.63-7.81-8.067-7.81z"
        fill="#fff"
      />
      <path
        d="M36.077 19.46a1.738 1.738 0 00-1.733 1.733v4.875a1.738 1.738 0 001.733 1.732 1.738 1.738 0 001.733-1.732v-4.875a1.738 1.738 0 00-1.733-1.732z"
        fill="#EC008C"
      />
      </g>
      <path
        d="M41.474 51l-5.216 5.216M31 51l5.216 5.216"
        stroke="#EC008C"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="arrow-down"
      />
      <circle cx="36" cy="36" r="35" stroke="#fff" strokeWidth="2" />
    </svg>
  )
}

export default ScrollAnimation